import { Box } from '@mui/material';
import type { SvgIconComponent } from '@mui/icons-material';
import Button, { ButtonColors } from 'components/Button/Button';
import Dialog, { DialogProps } from 'components/Dialog';
import { useLanguage } from 'context/AppContext';
import { ReactNode } from 'react';

export type OptionDialogProps = Omit<DialogProps, 'allowClose'> & {
  title: string;
  Icon?: SvgIconComponent;
  cancelButtonColor?: ButtonColors;
  footer?: ReactNode;
  disabled?: boolean;
};

export const OptionDialog = ({
  title,
  Icon,
  onConfirm,
  onCancel,
  onClose,
  cancelButtonColor = 'white on red',
  disabled,
  body = null,
  footer = null,
  ...props
}: OptionDialogProps) => {
  const lang = useLanguage()[0].OptionDialog;

  return (
    <Dialog
      {...{
        ...props,
        onCancel: undefined,
        onConfirm: undefined,
        sx: { ...props.sx, alignItems: 'center' },
      }}
      allowClose={!!onClose}
      onClose={onClose}
      title={title}
      body={
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: theme => theme.layout.spacing.large,
            padding: theme => theme.layout.spacing.medium,
          }}
        >
          <Box>{body}</Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: theme => theme.layout.spacing.small,
              //padding: theme => theme.layout.spacing.medium,
            }}
          >
            {Icon && (
              <Icon
                sx={{
                  width: '4em',
                  height: '4em',
                  color: theme => theme.colors.success,
                  alignSelf: 'center',
                  marginBottom: theme => theme.layout.spacing.medium,
                }}
              />
            )}
            <Button onClick={onConfirm} colors="white on active" disabled={disabled} sx={{ width: '100%' }}>
              {props.confirmLabel || lang.yes}
            </Button>
            <Button onClick={onCancel} colors={cancelButtonColor} disabled={disabled} sx={{ width: '100%' }}>
              {props.cancelLabel || lang.no}
            </Button>
          </Box>
          {!!footer && <Box sx={{ width: '100%', textAlign: 'center' }}>{footer}</Box>}
        </Box>
      }
    />
  );
};
